import { toHtml, isEmptyValue } from '../editor/content.js';

export const basic = {
  id: 'basic',
  name: 'Question & answer',
  short: 'Q & A',
  description: 'See the front, recall the back.',
  icon: 'card',
  fields: [
    {
      key: 'front',
      label: 'Front',
      hint: 'The question or prompt you’ll see first.',
      kind: 'rich',
      required: true,
      placeholder: 'Which nerve abducts the eye?',
    },
    {
      key: 'back',
      label: 'Back',
      hint: 'The answer, revealed when you tap the card.',
      kind: 'rich',
      required: true,
      placeholder: 'CN VI (abducens)',
    },
  ],
  ords: () => [0],
  cardLabel: () => 'Card',
  validate: (f) => (isEmptyValue(f.front) ? 'Front is empty.' : null),
  render: (note) => {
    const front = toHtml(note.fields.front);
    return {
      front,
      back: `${front}<hr class="answer-rule">${toHtml(note.fields.back)}`,
      mode: 'flip',
    };
  },
};

export const reversed = {
  id: 'reversed',
  name: 'Both directions',
  short: 'Both ways',
  description: 'Makes two cards, so you learn it both ways.',
  icon: 'swap',
  fields: [
    { ...basic.fields[0], hint: 'One side, e.g. a nerve.', placeholder: 'CN VII' },
    { ...basic.fields[1], hint: 'The other side, e.g. its name.', placeholder: 'Facial nerve' },
  ],
  ords: (note) => (isEmptyValue(note.fields?.back) ? [0] : [0, 1]),
  cardLabel: (ord) => (ord === 0 ? 'Front → back' : 'Back → front'),
  summary: (n) => (n === 2 ? 'One front → back, one back → front' : 'Fill in the back to get both directions'),
  validate: (f) =>
    isEmptyValue(f.front) ? 'Front is empty.' : isEmptyValue(f.back) ? 'Back is empty.' : null,
  render: (note, ord) => {
    const a = toHtml(ord === 0 ? note.fields.front : note.fields.back);
    const b = toHtml(ord === 0 ? note.fields.back : note.fields.front);
    return { front: a, back: `${a}<hr class="answer-rule">${b}`, mode: 'flip' };
  },
};
